import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: `
          radial-gradient(circle at 70% 40%, rgba(217,70,239,0.08), transparent 40%),
          radial-gradient(circle at 30% 70%, rgba(37,99,235,0.07), transparent 50%),
          #060C1B
        `,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        textAlign: 'center',
      }}
    >
      {/* 404 number */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }}
        style={{
          fontSize: 'clamp(6rem, 20vw, 12rem)',
          fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
          fontWeight: 800,
          lineHeight: 1,
          background: 'linear-gradient(135deg, #D946EF 0%, #9333EA 35%, #2563EB 70%, #00F0FF 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: '1rem',
          userSelect: 'none',
        }}
      >
        404
      </motion.div>

      {/* Message */}
      <motion.h1
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15, ease: [0.25, 0.46, 0.45, 0.94] }}
        style={{
          fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
          fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
          fontWeight: 700,
          color: '#ffffff',
          marginBottom: '1rem',
          letterSpacing: '-0.03em',
        }}
      >
        Page Not Found
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.25, ease: [0.25, 0.46, 0.45, 0.94] }}
        style={{
          color: '#64748B',
          fontSize: '1rem',
          maxWidth: '400px',
          lineHeight: 1.65,
          marginBottom: '2.5rem',
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      >
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </motion.p>

      <motion.a
        href="/"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.97 }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.5rem',
          background: '#ffffff',
          color: '#060C1B',
          fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
          fontWeight: 700,
          fontSize: '0.85rem',
          letterSpacing: '-0.01em',
          padding: '1rem 2.5rem',
          borderRadius: '0.875rem',
          textDecoration: 'none',
          boxShadow: '0 4px 24px rgba(255,255,255,0.12)',
          transition: 'background 0.2s ease',
        }}
        onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
        onMouseLeave={e => e.currentTarget.style.background = '#ffffff'}
      >
        Go Home
        <ArrowUpRight size={16} strokeWidth={2.5} />
      </motion.a>
    </div>
  );
};

export default NotFound;
